<template>
	<div class="custome-algolia-search-container">

			<ais-instant-search
			:search-client="searchClient"
			index-name="products"
			>
				<div class="algolia-search-input">
					<ais-search-box  v-if="sitelocale== 'ar'" placeholder="أكتب ما تبحث عنه" v-model="query" :class-names="{
						'ais-SearchBox-input': 'custome-search-input'}">
						<div slot="submit-icon"><i class="fas fa-search" aria-hidden="true"></i></div>
						 </ais-search-box>
						<ais-search-box  v-if="sitelocale== 'en'" placeholder="Search here" v-model="query" :class-names="{
							'ais-SearchBox-input': 'custome-search-input'}" ><div slot="submit-icon"><i class="fas fa-search" aria-hidden="true"></i></div></ais-search-box>
				</div>
				<div class="algolia-search-result is-hidden">
					<ais-hits>
						<div slot-scope="{ items}" v-if="items.length >0">
							<h4 class="has-text-weight-bold has- has-text-right m0 p10">
								<template v-if="sitelocale == 'ar'">
									المنتجات
								</template>
								<template v-else>
									Products
								</template>
							</h4>
						</div>
					</ais-hits>
					<ais-hits class="algolia-products">
						<ul class="ais-Hits-list" slot-scope="{ items }">
							<li class="ais-Hits-item mb5" v-for="item in items" :key="item.objectID" v-if="item.active">
								<p class="ais-product-text has-">
									<ais-highlight v-if="sitelocale == 'ar'" :hit="item" attribute="name" />
									<ais-highlight v-else :hit="item" attribute="name_en" />
								</p>
								<a :href="`/${sitelocale}/products/${item.slug}`" class="ais-product-link"></a>
							</li>
						</ul>
					</ais-hits>
				</div>
			</ais-instant-search>
			<div class="custome-algolia-search-result scrollbar-thumb-white scrollbar-track-primary hover:scrollbar-thumb-secondary-300 scrollbar-2xs">
				<div class="columns is-gapless">
					<div class="column is-6" :class="[sitelocale == 'ar' ? 'border-left' :'']">
						<div class="px-6">
							<ais-instant-search
							:search-client="searchClient"
							index-name="products"
							>
							<ais-configure
							:query="query"
							:hitsPerPage="8"
							/>
								<ais-hits>
									<div :class="[ items.length > 0 ? 'p10' : ''] " slot-scope="{ items}" v-if="items.length >0">
										<h4 class="mt-3 mb-3 has-text-weight-bold text-md rtl:pr-4 ltr:pl-4">
										<template v-if="sitelocale == 'ar'">
											المنتجات
										</template>
										<template v-else>
											Products
										</template>
										</h4>
									</div>
								</ais-hits>
								<ais-hits class="flex content-start justify-center border-white rtl:border-l ltr:border-r">
									<ul :class="[ items.length > 0 ? 'p10' : ''] " class="ais-Hits-list" slot-scope="{ items }">
										<li class="ais-Hits-item mb5" v-for="item in items" :key="item.objectID" v-if="item.active">
											<a :href="`/${sitelocale}/products/${item.slug}`" class=" is-size-7 has-text-weight-normal ais-product-link">
												<ais-highlight v-if="sitelocale == 'ar'" :hit="item" attribute="name" />
												<ais-highlight v-else :hit="item" attribute="name_en" />
											</a>
										</li>
									</ul>

								</ais-hits>

							</ais-instant-search>
						</div>
					</div>
					<div class="column is-6" :class="[sitelocale == 'en' ? 'border-left' :'']">
						<div class="px-6">
							<ais-instant-search
							:search-client="searchClient"
							index-name="merchants"
							>
							<ais-configure
							:query="query"
							:hitsPerPage="8"
							/>
								<ais-hits>
									<div :class="[ items.length > 0 ? 'p10' : ''] " slot-scope="{ items}" v-if="items.length >0">
										<h4 class="mt-3 mb-3 has-text-weight-bold text-md rtl:pr-4 ltr:pl-4">
										<template v-if="sitelocale == 'ar'">
											مقدمي الخدمة
										</template>
										<template v-else>
											Service Providers
										</template>
										</h4>
									</div>
								</ais-hits>
								<ais-hits class="algolia-brands">
									<ul :class="[ items.length > 0 ? 'p10' : ''] " class="ais-Hits-list" slot-scope="{ items }">
										<li class="ais-Hits-item mb5" v-for="item in items" :key="item.objectID" v-if="item.active == true || item.active == 1 ">
											<a :href="`/${sitelocale}/merchants/${item.email}/`"  class="is-size-7 has-text-weight-normal ais-product-text">
												<ais-highlight v-if="sitelocale == 'ar'" :hit="item" attribute="name" />
												<ais-highlight v-else :hit="item" attribute="name_en" />
											</a>
										</li>
									</ul>
								</ais-hits>

							</ais-instant-search>
						</div>
					</div>
				</div>
			</div>



</div>
</template>

<script>
	import algoliasearch from 'algoliasearch/lite';
	const algoliaClient = algoliasearch(
		'OCBB70RZ8N',
		'7bffbf4863fa63970c987ce076042fc2'
		);
	const searchClient = {
		search(requests) {
			if (requests.every(({ params }) => !params.query)) {
				return Promise.resolve({
					results: requests.map(() => ({
						hits: [],
						nbHits: 0,
						processingTimeMS: 0,
					})),
				});

			}
			return algoliaClient.search(requests);
		},
	};
	export default {
		props: {
			sitelocale:{
				type: String,
				required: true
			},
			link:{
				type: String,
				required: true
			}
		},
		data() {
			return {
				searchClient,
				query: '',
				OpenSearch:false
			};
		},
		mounted() {
			this.$translate.setLang(this.sitelocale);
		},
		methods:{
			submit(input){
				if(input){
					window.location.href = `${this.link}?search=${input}`;
				}
			},

		},
		watch: {
			query: function (val) {
				if (val == ''){
					this.OpenSearch=false
				}
				else{
					this.OpenSearch=true
					let link = this.link;
					document.querySelector('.custome-search-input').addEventListener('keypress', function (e) {
						var key = e.which || e.keyCode;
					    if (key === 13) { // 13 is enter
					    	window.location.href = `${link}?search=${val}`;
					    }
					});

				}
			},
		}


	};
</script>
